'use client';

import clsx from 'clsx';
import { FC, useContext, useState } from 'react';
import FormCheckbox from '@/components/FormCheckbox';
import AlgonomyContext, { AlgonomyContextState } from '@/context/SearchResultsContext';

import { FilterCheckBoxProps } from './types';
import styles from './FilterCheckBox.module.css';

const FilterCheckBox: FC<FilterCheckBoxProps> = ({ label, selected, filterFacet, filterValue, filterName }) => {
  const [isSelected, setIsSelected] = useState<boolean>(selected);
  const { handleSelectFilter, isLoading } = useContext(AlgonomyContext) as AlgonomyContextState;
  return (
    <FormCheckbox
      checkboxMainContainerClasses={styles.filterCheckbox}
      checkboxLabelClassName={clsx(styles.filterLabel, {
        [styles.selected]: selected,
        ['loading']: isLoading,
      })}
      checkboxControllerClassName={styles.filterController}
      id={label}
      value={isSelected}
      onChange={(val: React.ChangeEvent<HTMLInputElement>) => {
        if (isLoading) return;
        setIsSelected(!isSelected);
        handleSelectFilter(filterFacet, filterValue, filterName, val.target.checked);
      }}
      label={label}
      labelClick
    />
  );
};

export default FilterCheckBox;
